import { useCallback, useState } from 'react';

export default function useOpenClose(initValue = false) {
    const [isOpen, setIsOpen] = useState(initValue);

    const toggle = useCallback(value => {
        if (typeof value === 'boolean') setIsOpen(value);
        return setIsOpen(prev => !prev);
    }, []);

    const doOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const doClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    return { isOpen, doOpen, doClose, toggle };
}
